import React, {PropsWithChildren, useEffect, useState} from "react";
import {useIntl} from "react-intl";
import {observer} from "mobx-react-lite";
import {useStore} from "@ui/stores";
import {setIntlProvider} from "@ui/common/intl";
import Auth from "@ui/components/auth";
import Loader from "@ui/components/common/Loader"

const UserProvider = ({children}: PropsWithChildren<{}>): React.ReactElement => {
  const [loaded, setLoaded] = useState<boolean>(false);
  const {user} = useStore();
  const intl = useIntl();

  useEffect(() => setIntlProvider(intl), [intl]);

  useEffect(() => {
    user.check()
			.catch(e => console.log("login error", e))
      .finally(() => setLoaded(true))
	}, []);

  return (
    <>
      {
        !loaded
        ? <Loader />
        : !user.authenticated
          ? <Auth />
          : children
      }
    </>
  );
}

export default observer(UserProvider);
